import { Client, Functions } from "appwrite";
import conf from "../conf/conf";
import { APPWRITE_PROMPT_FUNCTION_ID } from "../AppWrite/appwrite";

const client = new Client()
  .setEndpoint(conf.appwrite_url)
  .setProject(conf.appwrite_project_id);

const functions = new Functions(client);

const extractJSONObject = (text) => {
  if (typeof text !== "string") return null;

  // try 1: plain JSON
  try {
    return JSON.parse(text);
  } catch {}

  // try 2: strip code fences
  const cleaned = text.replace(/```json|```/gi, "").trim();
  try {
    return JSON.parse(cleaned);
  } catch {}

  // try 3: grab the first {...} block
  const m = cleaned.match(/\{[\s\S]*\}/);
  if (m) {
    try {
      return JSON.parse(m[0]);
    } catch {}
  }
  return null;
};

export const handlePrompt = async () => {
  try {
    const execution = await functions.createExecution(
      APPWRITE_PROMPT_FUNCTION_ID,
      JSON.stringify({
        prompt: `Generate 5 motivational quotes related to hard work, technology, and accepting challenges from famous personalities around the world. Include the name of the person who said each quote, prefixed with a "~" (e.g., "quote....." ~Elon Musk).  
Return ONLY a JSON array of strings  with no additional text or formatting.`,
      })
    );

    const body = execution?.responseBody ?? "";
    let parsed = Array.isArray(body) ? body : null;

    if (!parsed) {
      // handle cases where the function returns JSON text
      try {
        parsed = JSON.parse(body);
      } catch {
        // maybe wrapped with fences or contains logs
        parsed = extractJSONObject(body);
      }
    }

    const reply = Array.isArray(parsed)
      ? parsed
      : Array.isArray(parsed?.reply)
      ? parsed.reply
      : [];

    return { reply };
  } catch (error) {
    console.error("Error in handlePrompt:", error);
    return { reply: [] };
  }
};
